const app = require('loginApp');
// Bootstrap is required so that bootstrap js code needed for things like btn dropdowns is included in the login app. 
const Bootstrap = require('bootstrap'),
    marionette = require('backbone.marionette'),
    behaviorLocator = require('shared/behavior/behaviorLocator');

// RESOURCES
require('./content/less/login.less');
require('../node_modules/select2/select2.css');
require('../node_modules/select2-bootstrap-css/select2-bootstrap.css');
require('./content/img/Download_on_the_App_Store.svg');
require('./content/img/Download_on_the_App_Store-ES.svg');
require('./content/img/google-play-badge.png');
require('./content/img/google-play-badge-es.png');
require('./content/img/login-badge-li.png');

// OTHER (apps, extensions, etc)
require('backbone.validation');
require('shared/extensions/backboneValidationBootstrap');
require('shared/extensions/backboneExt');

// VIEW ROUTERS (A-Z!)
require('shared/router/loginRouter');
require('shared/router/passwordResetRouter');
require('shared/router/requestAccessRouter');

marionette.Behaviors.behaviorsLookup = behaviorLocator;

app.start();